import { CreateUser, UpdateUser, User } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { Page } from "./domain";
import { WithDelete } from "./mixins/WithDelete";
import { WithEdit } from "./mixins/WithEdit";
import { WithSearchableGetPage } from "./mixins/WithSearchableGetPage";
import { GetAllUsersQuery } from "./query/GetAllUsersQuery";

export class Endpoint extends BaseEndpoint("users") {}

const withEdit = WithEdit<typeof Endpoint, User, CreateUser, UpdateUser>(Endpoint);

const withDelete = WithDelete(withEdit);

const SearchableGetPage = WithSearchableGetPage<typeof withEdit, User, Page<User>>(withDelete);

export class UserEndpoint extends SearchableGetPage {
  getAll(query?: GetAllUsersQuery): Promise<User[]> {
    return this.request("all", { query });
  }

  getMembers(query?: {
    query?: string;
    rights?: string[];
  }): Promise<Page<{ id: string; firstName: string | undefined; lastName: string | undefined }>> {
    return this.request("members", { query });
  }

  ensureValidator(body: { userId: string; pin: string }): Promise<boolean> {
    return this.request("ensure-validator", { method: "POST", body });
  }
}
